export default (state = {
    showCompany: true
}, action) => {
    switch (action.type) {
      case "SET_SHOW_COMPANY":
        return Object.assign({}, state, { showCompany: action.payload });;
      default:
        return state;
    }
  };